import { ReadingField } from './types';

export const READING_FIELDS: ReadingField[] = [
  {
    id: 'ot',
    label: 'Old Testament Reading',
    key: 'ot_reading',
    placeholder: 'Enter Old Testament reading reference'
  },
  {
    id: 'psalm',
    label: 'Psalm Reading',
    key: 'psalm_reading',
    placeholder: 'Enter Psalm reading reference'
  },
  {
    id: 'nt',
    label: 'New Testament Reading',
    key: 'nt_reading',
    placeholder: 'Enter New Testament reading reference'
  },
  {
    id: 'gospel',
    label: 'Gospel Reading',
    key: 'gospel_reading',
    placeholder: 'Enter Gospel reading reference'
  }
];